/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

import Api from '../../../../util/api';
import { Integer, PageDo, ResultPageDo, Result } from '../../../../types/base';
import { defaultNullValue } from 'src/config';

export declare namespace AlarmStatisticsDOI {
    export interface RowDataI {
        city_id       : number;
        city_name     : string;
        count         : number;
        device_id     : number;
        device_lost   : number;
        device_offline: number;
        district_id   : number;
        district_name : string;
        meter_break   : number;
        meter_warning : number;
        name          : string;
        over_time     : number;
        over_warning  : number;
        power_low     : number;
        processed     : number;
        province_id   : number;
        province_name : string;
        sys_break     : number;
        untreated     : number;
    }

    export interface QueryRowDataParamsI extends PageDo {
        province_id?: number;
        city_id?    : number;
        district_id?: number;
        end_time?   : string;
        start_time? : number;
        site_type?  : number;
    }
    export interface ResultI {
        over_warning_count  : number  //# 因子超标总数
        power_low_count     : number  //		# 电量不足总数
        device_lost_count   : number  //		设备偏移总数
        over_time_count     : number  //	设备维护周期不足总数
        meter_break_count   : number  //	仪表故障告警总数
        device_offline_count: number  //		设备离线总数
        meter_warning_count : number  //		仪表常规告警总数
        sys_break_count     : number  //	系统故障告警
        processed_count     : number  //	已通知总数
        untreated_count     : number  //	未通知总数
        count_count         : number  //	总报警数
        city_name           : number  //	市
        district_name       : number  //		区
        province_name       : number  //		省
        data_info           : AlarmStatisticsDOI.RowDataI[]  //以上的信息去掉count就是data_info内其他字段信息
    }
}
export default class alarmStatisticsApi {
    /**
     * 查询列表
     * @param {GetPeopleManageListParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: AlarmStatisticsDOI.QueryRowDataParamsI): Promise<Result<AlarmStatisticsDOI.ResultI>> {
        return Api.post('/monitor/alarm/count', {
            province_id: defaultNullValue,
            city_id: defaultNullValue,
            district_id: defaultNullValue,
            infrom_status: defaultNullValue,
            type: defaultNullValue,
            end_time  : '',
            start_time : '',
            ...params,
        });
    }

    static async exportAll(params: AlarmStatisticsDOI.QueryRowDataParamsI):Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/export/alarm/count',{
            province_id: defaultNullValue,
            city_id: defaultNullValue,
            district_id: defaultNullValue,
            infrom_status: defaultNullValue,
            type: defaultNullValue,
            end_time  : '',
            start_time : '',
            ...params
        })
    }

}
